import { Component } from '@angular/core';
import { AutoMlService } from 'src/app/core/service/auto-ml.service';

@Component({
  selector: 'app-auto-ml-preview',
  templateUrl: './auto-ml-preview.component.html',
  styleUrls: ['./auto-ml-preview.component.scss']
})
export class AutoMlPreviewComponent {

  selectedTab:string ='tab1';
  typeOfIncome:string='Results';

  constructor(
    public autoMlService:AutoMlService
  ){}

  selectTab(tabName: string): void {
    this.selectedTab = tabName;
  }

  selectedTableIndex:number=0;

  pageArr=[
    5,10,25
  ];

  page=1;
  selectedPage=5;

  getTableKey(){
    return Object.keys(this.autoMlService.resultPreviewData[this.selectedTableIndex].results[0]);
  }

  getRankTableKey(){
    return Object.keys(this.autoMlService.rankCompareTableData[0]);
  }

  getScoreTableKey(){
    return Object.keys(this.autoMlService.scoreCompareTableData[0]);
  }

  getTableData(){
    return this.autoMlService.resultPreviewData[this.selectedTableIndex].results;
  }


  sampleData:any ={
    "rank_data": [
        {
            "variable_name": "bnx_batch",
            "iteration_rank_data": [
                {
                    "name": "Iteration 1",
                    "rank": 8
                }
            ]
        },
        {
            "variable_name": "Product_Other",
            "iteration_rank_data": [
                {
                    "name": "Iteration 1",
                    "rank": 2
                }
            ]
        },
        {
            "variable_name": "Age",
            "iteration_rank_data": [
                {
                    "name": "Iteration 1",
                    "rank": 8
                }
            ]
        },
        {
            "variable_name": "Product_A",
            "iteration_rank_data": [
                {
                    "name": "Iteration 1",
                    "rank": 5
                }
            ]
        },
        {
            "variable_name": "maxd_test1",
            "iteration_rank_data": [
                {
                    "name": "Iteration 1",
                    "rank": 3
                }
            ]
        },
        {
            "variable_name": "Product_F",
            "iteration_rank_data": [
                {
                    "name": "Iteration 1",
                    "rank": 4
                }
            ]
        },
        {
            "variable_name": "Gender",
            "iteration_rank_data": [
                {
                    "name": "Iteration 1",
                    "rank": 7
                }
            ]
        },
        {
            "variable_name": "week_test1",
            "iteration_rank_data": [
                {
                    "name": "Iteration 1",
                    "rank": 6
                }
            ]
        },
        {
            "variable_name": "sumd_test1",
            "iteration_rank_data": [
                {
                    "name": "Iteration 1",
                    "rank": 1
                }
            ]
        }
    ],
    "importance_score_data": [
        {
            "variable_name": "bnx_batch",
            "iteration_score_data": [
                {
                    "name": "Iteration 1",
                    "score": 0
                }
            ]
        },
        {
            "variable_name": "Product_Other",
            "iteration_score_data": [
                {
                    "name": "Iteration 1",
                    "score": 20.29
                }
            ]
        },
        {
            "variable_name": "Age",
            "iteration_score_data": [
                {
                    "name": "Iteration 1",
                    "score": 0
                }
            ]
        },
        {
            "variable_name": "Product_A",
            "iteration_score_data": [
                {
                    "name": "Iteration 1",
                    "score": 13.95
                }
            ]
        },
        {
            "variable_name": "maxd_test1",
            "iteration_score_data": [
                {
                    "name": "Iteration 1",
                    "score": 19.8
                }
            ]
        },
        {
            "variable_name": "Product_F",
            "iteration_score_data": [
                {
                    "name": "Iteration 1",
                    "score": 14.37
                }
            ]
        },
        {
            "variable_name": "Gender",
            "iteration_score_data": [
                {
                    "name": "Iteration 1",
                    "score": 2.21
                }
            ]
        },
        {
            "variable_name": "week_test1",
            "iteration_score_data": [
                {
                    "name": "Iteration 1",
                    "score": 8.81
                }
            ]
        },
        {
            "variable_name": "sumd_test1",
            "iteration_score_data": [
                {
                    "name": "Iteration 1",
                    "score": 20.57
                }
            ]
        }
    ]
}


}
